"use client";

import { Loader } from "@forestsync/ui";
import { type CarbonSinkDetail } from "@/types/glassroom";
import dynamic from "next/dynamic";

// Lazy load the heavy map component with better loading state
const DynamicSinkMap = dynamic(() => import("./DynamicSinkMap"), {
  ssr: false,
  loading: () => (
    <div className="w-full h-full bg-gray-200 dark:bg-gray-700 rounded-lg flex items-center justify-center">
      <Loader type="bars" size="xl" />
    </div>
  ),
});

interface SinkMapProps {
  sink: CarbonSinkDetail;
}

export function SinkMap({ sink }: SinkMapProps) {
  return <DynamicSinkMap sink={sink} />;
}
